import { ProductDeliveryPromiseExplanations, ProductTileVerticalFormat } from './product-detail/ProductTypes';
import { ProductLister } from './product-lister';

export type WishlistContainerProps = {
  title?: string;
  deliveryPromiseExplanations: ProductDeliveryPromiseExplanations;
  tileFormat: ProductTileVerticalFormat;
};

export type WishlistProduct = {
  colorId: number;
  productCode: string;
  productId: number;
  sku?: string | number;
  colorCode?: string;
  color?: string;
};

export type WishlistProductsResponse = {
  products: Array<WishlistProduct>;
};

export type WishlistListerProductsResponse = {
  itemCount: number;
  items: Array<ProductLister>;
  totalPages: number;
};

export type WishlistMenuItemContainerProps = {
  link: string;
};

export type WishlistAnalyticsData = {
  isPDP: boolean;
  isWishlistPage: boolean;
  product: WishlistProduct;
};
